import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'mbraun',
} as IModuleProps;
